var _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 256,
    height: 256,
    viewBox: "0 0 256 256",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), /*#__PURE__*/React.createElement("g", {
    style: {
      stroke: "none",
      strokeWidth: 0,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "none",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "translate(1.4065934065934016 1.4065934065934016) scale(2.81 2.81)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 23.575 89.924 H 1.407 V 28.439 h 22.167 V 89.924 z M 5.835 85.496 h 13.311 v -52.63 H 5.835 V 85.496 z M 12.491 25.072 C 5.603 25.072 0 19.467 0 12.576 c 0 -6.893 5.603 -12.5 12.491 -12.5 c 6.887 0 12.491 5.608 12.491 12.5 C 24.982 19.467 19.379 25.072 12.491 25.072 z M 12.491 4.504 c -4.446 0 -8.063 3.621 -8.063 8.072 c 0 4.448 3.617 8.068 8.063 8.068 c 4.446 0 8.063 -3.619 8.063 -8.068 C 20.554 8.125 16.937 4.504 12.491 4.504 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 90 89.924 H 67.846 V 59.962 c 0 -8.75 -1.048 -12.915 -7.001 -12.915 c -6.14 0 -8.422 3.371 -8.422 12.439 v 30.438 H 30.269 V 28.439 h 21.439 v 4.046 c 3.376 -3.03 8.363 -5.459 14.806 -5.459 C 87.21 27.025 90 41.883 90 56.417 V 89.924 z M 72.274 85.496 h 13.298 v -29.08 c 0 -15.411 -3.189 -24.963 -19.059 -24.963 c -7.81 0 -12.864 4.328 -14.819 8.035 l -0.623 1.181 h -3.792 v -7.803 H 34.697 v 52.63 h 13.298 v -26.01 c 0 -4.614 0 -16.867 12.85 -16.867 c 11.429 0 11.429 11.282 11.429 17.343 V 85.496 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.1fb29a6cb4b69c023d33a670314a8eaf.svg";
export { ForwardRef as ReactComponent };